<kt-portlet>

	<!-- <kt-portlet-header [sticky]="true" [title]="'Machine List'" [class]="'kt-portlet__head--lg'" [viewLoading$]="dataSource.loading$"> -->

	<!-- </kt-portlet-header> -->
	<!-- end::Header -->

	<kt-portlet-body>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<div class="hierarchical-filters">
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select type</label>
					<kt-searchable-select
						[options]="typeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="typeSelected"
						(selectionChange)="typeChanged($event)">
					</kt-searchable-select>
				</div>
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select mode</label>
					<kt-searchable-select
						[options]="modeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="modeSelected"
						(selectionChange)="modeChanged($event)">
					</kt-searchable-select>
				</div>
			</div>
			<!-- end::FILTERS -->
		</div>



		<!-- end::FILTERS & GROUP ACTIONS -->


		<div class="mat-table__wrapper">

			<mat-table class="lmat-elevation-z8"
				#table
				[dataSource]="dataSource"
				matSort
				matSortActive="uploaded_at"
				matSortDirection="desc"
				matSortDisableClear>

				<ng-container matColumnDef="file_version">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
					<mat-cell *matCellDef="let file">
						{{file.file_version}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="file_desc">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
					<mat-cell *matCellDef="let file">{{file.file_desc}}</mat-cell>
				</ng-container>



				<ng-container matColumnDef="file_name">
					<mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
					<mat-cell *matCellDef="let file">{{file.file_name}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="uploaded_at">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded at</mat-header-cell>
					<mat-cell *matCellDef="let file">
						{{file.uploaded_at}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
					<mat-cell *matCellDef="let file">
						<button (click)="editFile(editFileComp, file)" mat-icon-button color="primary" matTooltip="Edit File">
							<mat-icon>edit</mat-icon>
						</button>&nbsp;
						<button (click)="deleteFile(deleteConfirm, file)" mat-icon-button matTooltip="Delete File">
							<mat-icon class="mat-danger-text">delete</mat-icon>
						</button>&nbsp;
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>

			<div class="mat-table__message" *ngIf="(!modeSelected || !typeSelected)">Please Select File Type and Mode</div>
			<div class="mat-table__message" *ngIf="(dataSource.loading$ | async)">Please wait....</div>
			<div class="mat-table__message" *ngIf="dataSource.empty">No records found</div>
		</div>

		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>
</kt-portlet>

 <!-- Delete Confirmation PopUP -->
<ng-template #deleteConfirm let-c="close" let-d="dismiss">
	<div class="modal-body text-center">
		<br>
		Do you want to delete?
		<br>
		<br>
		<div class="text-center">
			<button mat-raised-button  (click)="c('close')">Cancel</button> &nbsp;
			<button mat-raised-button class="mat-danger" (click)="c('delete')" color="primary">Delete</button>
		</div>
	</div>
</ng-template>


<!-- Edit modal -->
<ng-template #editFileComp let-c="close" let-d="dismiss">
	<div class="modal-header">
	  <h4 class="modal-title">Edit</h4>
	  <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
		<span aria-hidden="true">&times;</span>
	  </button>
	</div>
	<div class="modal-body">
		<div class="row mt-3">
			<div class="col-lg-4 col-md-6 col-sm-10">
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select type</label>
					<kt-searchable-select
						[options]="typeOptions"
						[multiple]="false"
						[searchable]="false">
					</kt-searchable-select>
				</div>
			</div>
			<div class="col-lg-4 col-md-6 col-sm-10">
				<mat-form-field>
					<input matInput placeholder="Version #">
				</mat-form-field>
			</div>
		</div>


		<p>
			<mat-form-field class="example-form">
				<mat-label>Description</mat-label>
				<textarea matInput></textarea>
			</mat-form-field>
		</p>

		<!-- <mat-label>Compatible Versions</mat-label> -->

		<div class="row">
			<div class="col">
				<mat-card>
					<mat-card-header>
					  <mat-card-subtitle>Compatible Versions</mat-card-subtitle>
					</mat-card-header>
					<mat-card-content style="height: 150px;">
						<mat-chip-list>
							<mat-chip *ngFor="let chip of availableColors" selected="true" color="primary">
							  {{chip.name}}
							  <mat-icon matChipRemove style="color: red;">remove_circle</mat-icon>
							</mat-chip>
						  </mat-chip-list>
					</mat-card-content>
				  </mat-card>

			</div>
			<div class="col">
				<mat-card>
					<mat-card-header>
					  <mat-card-subtitle>In-Compatible Versions</mat-card-subtitle>
					</mat-card-header>
					<mat-card-content style="height: 150px;">
						<mat-chip-list>
							<mat-chip *ngFor="let chip of availableColors" selected="false">
							  {{chip.name}}
							  <mat-icon matChipRemove style="color: green;">add_circle</mat-icon>
							</mat-chip>
						  </mat-chip-list>
					</mat-card-content>
				  </mat-card>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button mat-raised-button  (click)="c('Close click')">Cancel</button> &nbsp;
		<button mat-raised-button color="primary">Update</button>
	</div>
  </ng-template>
